/**
 * Constants shared between the server-side GitHub sync library and the
 * client settings UI (which cannot import lib/github-sync.ts because it
 * pulls in node:crypto and the db pool).
 */
export const DEFAULT_SYNC_REPO_NAME = 'beyondctci-code-submissions'
export const BCTCI_REPO_MARKER_TEXT =
  'This repository is managed by BeyondCTCI GitHub sync.'
export const EXTERNAL_SYNC_ROOT_DIR = DEFAULT_SYNC_REPO_NAME

function isLikelyLegacyBctciRepoName(repoName: string): boolean {
  return (
    repoName === DEFAULT_SYNC_REPO_NAME ||
    repoName.startsWith(`${DEFAULT_SYNC_REPO_NAME}-`)
  )
}

function isBctciManagedReadme(readmeText: string): boolean {
  const normalized = readmeText.toLowerCase()
  return (
    normalized.includes(BCTCI_REPO_MARKER_TEXT.toLowerCase()) ||
    normalized.includes('# beyondctci submission sync') ||
    normalized.includes('one-way sync from beyondctci to github')
  )
}

export function isBctciManagedRepository(params: {
  repoName: string
  readmeText: string | null
}): boolean {
  if (params.readmeText) {
    return isBctciManagedReadme(params.readmeText)
  }
  // Backward compatibility: legacy repos created before marker enforcement can
  // still be reconnected using the default BeyondCTCI naming convention.
  return isLikelyLegacyBctciRepoName(params.repoName)
}

export type GitHubSetupTargetMode =
  | 'create_new'
  | 'use_existing_bctci'
  | 'use_existing_external'
